import store from '@/store';
import {SnackbarColor, SnackbarOptions} from '@/store/modules/snackbar';
import {Snackbar} from '@/types/snackbar';

export default <Snackbar>{
  fire(options: SnackbarOptions) {
    return store.dispatch('snackbar/fire', options);
  },
  show(
    message: string,
    color: SnackbarColor = 'info',
    options?: SnackbarOptions,
  ) {
    return store.dispatch('snackbar/show', {message, color, options});
  },
  hide() {
    return store.dispatch('snackbar/hide');
  },
};
